export const ACCENT_OPTIONS = ['teal', 'violet', 'blue', 'emerald', 'red', 'orange', 'yellow', 'rainbow']
export const LANGUAGE_OPTIONS = ['de', 'en', 'tr', 'es', 'el', 'nl', 'fr', 'it', 'pt', 'ru', 'zh', 'ja', 'ar', 'hi', 'ko', 'pl']

const STORAGE_KEY = 'ai-mastering-preferences'
const defaults = {
  language: 'de',
  accent: 'teal',
  compactList: false,
  dateFormat: 'medium',
}

/** Hex-Werte für CSS --accent (Violett = Legacy-Name, optisch Studio-Teal). */
export const ACCENT_HEX = {
  teal: '#00d4aa',
  violet: '#00d4aa',
  blue: '#3b82f6',
  emerald: '#10b981',
  red: '#ef4444',
  orange: '#f97316',
  yellow: '#eab308',
  rainbow: '#00d4aa',
}

export function loadPreferences() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return { ...defaults }
    const data = JSON.parse(raw)
    let accent = ACCENT_OPTIONS.includes(data.accent) ? data.accent : 'teal'
    // Alter Default „violet“ → Studio-Teal (einmalig migrieren)
    if (accent === 'violet' && data._accentMigrated !== true) {
      accent = 'teal'
    }
    return {
      language: LANGUAGE_OPTIONS.includes(data.language) ? data.language : 'de',
      accent,
      compactList: Boolean(data.compactList),
      dateFormat: data.dateFormat === 'short' || data.dateFormat === 'long' ? data.dateFormat : 'medium',
      _accentMigrated: true,
    }
  } catch {
    return { ...defaults, _accentMigrated: true }
  }
}

export function savePreferences(prefs) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs))
  } catch (_) {}
}

export const translations = {
  de: {
    'settings.title': 'Einstellungen',
    'settings.general': 'Allgemein',
    'settings.profile': 'Profil',
    'settings.users': 'Benutzerverwaltung',
    'settings.generalIntro': 'Sprache, Akzentfarbe und Anzeigeoptionen – werden nur in deinem Browser gespeichert und wirken sofort.',
    'settings.language': 'Sprache',
    'settings.language.de': 'Deutsch',
    'settings.language.en': 'English',
    'settings.language.tr': 'Türkisch',
    'settings.language.es': 'Spanisch',
    'settings.language.el': 'Griechisch',
    'settings.language.nl': 'Niederländisch',
    'settings.language.fr': 'Französisch',
    'settings.language.it': 'Italienisch',
    'settings.language.pt': 'Portugiesisch',
    'settings.language.ru': 'Russisch',
    'settings.language.zh': 'Chinesisch',
    'settings.language.ja': 'Japanisch',
    'settings.language.ar': 'Arabisch',
    'settings.language.hi': 'Hindi',
    'settings.language.ko': 'Koreanisch',
    'settings.language.pl': 'Polnisch',
    'settings.accent': 'Akzentfarbe',
    'settings.accent.teal': 'Teal (Studio)',
    'settings.accent.violet': 'Violett',
    'settings.accent.blue': 'Blau',
    'settings.accent.emerald': 'Smaragdgrün',
    'settings.accent.red': 'Rot',
    'settings.accent.orange': 'Orange',
    'settings.accent.yellow': 'Gelb',
    'settings.accent.rainbow': 'Bunt',
    'settings.dateFormat': 'Datumsformat',
    'settings.dateFormat.short': 'Kurz (TT.MM.JJ)',
    'settings.dateFormat.medium': 'Mittel (z. B. 22. Feb. 2026)',
    'settings.dateFormat.long': 'Lang (vollständig)',
    'settings.compactList': 'Kompakte Listenansicht',
    'nav.dashboard': 'Dashboard',
    'nav.upload': 'Upload',
    'nav.buyCredits': 'Credits bestellen',
    'nav.jobs': 'Jobs',
    'nav.masters': 'Meine Masters',
    'nav.compare': 'Vergleich',
    'nav.settings': 'Einstellungen',
    'nav.track': 'Track',
    'page.dashboard': 'Dashboard',
    'page.masters': 'Meine Masters',
    'page.compare': 'Vergleich',
    'page.settings': 'Einstellungen',
  },
  en: {
    'settings.title': 'Settings',
    'settings.general': 'General',
    'settings.profile': 'Profile',
    'settings.users': 'User management',
    'settings.generalIntro': 'Language, accent colour and display options are stored in your browser only and apply immediately.',
    'settings.language': 'Language',
    'settings.language.de': 'Deutsch',
    'settings.language.en': 'English',
    'settings.language.tr': 'Turkish',
    'settings.language.es': 'Spanish',
    'settings.language.el': 'Greek',
    'settings.language.nl': 'Dutch',
    'settings.language.fr': 'French',
    'settings.language.it': 'Italian',
    'settings.language.pt': 'Portuguese',
    'settings.language.ru': 'Russian',
    'settings.language.zh': 'Chinese',
    'settings.language.ja': 'Japanese',
    'settings.language.ar': 'Arabic',
    'settings.language.hi': 'Hindi',
    'settings.language.ko': 'Korean',
    'settings.language.pl': 'Polish',
    'settings.accent': 'Accent colour',
    'settings.accent.teal': 'Teal (Studio)',
    'settings.accent.violet': 'Violet',
    'settings.accent.blue': 'Blue',
    'settings.accent.emerald': 'Emerald',
    'settings.accent.red': 'Red',
    'settings.accent.orange': 'Orange',
    'settings.accent.yellow': 'Yellow',
    'settings.accent.rainbow': 'Colourful',
    'settings.dateFormat': 'Date format',
    'settings.dateFormat.short': 'Short (MM/DD/YY)',
    'settings.dateFormat.medium': 'Medium (e.g. Feb 22, 2026)',
    'settings.dateFormat.long': 'Long (full)',
    'settings.compactList': 'Compact list view',
    'nav.dashboard': 'Dashboard',
    'nav.upload': 'Upload',
    'nav.buyCredits': 'Buy credits',
    'nav.jobs': 'Jobs',
    'nav.masters': 'Masters',
    'nav.compare': 'Compare',
    'nav.settings': 'Settings',
    'nav.track': 'Track',
    'page.dashboard': 'Dashboard',
    'page.masters': 'Masters',
    'page.compare': 'Compare',
    'page.settings': 'Settings',
  },
}
